import { render, staticRenderFns } from "./FloatFrameResizeMargin.vue?vue&type=template&id=db70df7e&"
import script from "./FloatFrameResizeMargin.vue?vue&type=script&lang=js&"
export * from "./FloatFrameResizeMargin.vue?vue&type=script&lang=js&"
import style0 from "./FloatFrameResizeMargin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports